import { useCallback, useContext } from 'react';

import { FavouritesContext } from '../../state/favourites';
import type { FavouriteCategory } from '../../state/favourites/reducer';

const useFavourite = (
  category: FavouriteCategory,
  value: number,
  getField = ({ id }: { id: number }) => id
) => {
  const {
    actions: { addFavourite, removeFavourite },
    ...favourites
  } = useContext(FavouritesContext);

  const values: Array<{ id: number }> = favourites[category];

  const favourited = values.map(getField).includes(value);

  const toggleFavourite = useCallback(
    () =>
      favourited
        ? removeFavourite(value, category)
        : addFavourite(value, category),
    [favourited, addFavourite, removeFavourite, value, category]
  );

  // A tuple, not an array, so destructuring keeps the flag and the toggle
  // distinct rather than giving both the union of the two.
  return [favourited, toggleFavourite] as const;
};

export default useFavourite;
